// Customer follow-up worklist.
window.PlummeI18n.register('no', {
  'ap.customerFollowup.title': 'Kundeoppfølging',
  'ap.customerFollowup.waiting': 'Venter på svar',
  'ap.customerFollowup.ready': 'Klar for tilbud',
  'ap.customerFollowup.document': 'Tilbud eller ordre til oppfølging',
  'ap.customerFollowup.openChat': 'Åpne chat',
  'ap.customerFollowup.empty': 'Ingen kunder trenger oppfølging nå.',
});
window.PlummeI18n.register('en', {
  'ap.customerFollowup.title': 'Customer follow-up',
  'ap.customerFollowup.waiting': 'Waiting for a reply',
  'ap.customerFollowup.ready': 'Ready for an offer',
  'ap.customerFollowup.document': 'Offer or order to follow up',
  'ap.customerFollowup.openChat': 'Open chat',
  'ap.customerFollowup.empty': 'No customers need follow-up right now.',
});
